/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Giftcard: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.7071 3.29289C10.3166 2.90237 9.68342 2.90237 9.29289 3.29289C8.90237 3.68342 8.90237 4.31658 9.29289 4.70711L9.58591 5.00012H6C3.79086 5.00012 2 6.79098 2 9.00012V17.0001C2 19.2093 3.79086 21.0001 6 21.0001H18C20.2091 21.0001 22 19.2093 22 17.0001V9.00012C22 6.79098 20.2091 5.00012 18 5.00012H14.4141L14.7071 4.70711C15.0976 4.31658 15.0976 3.68342 14.7071 3.29289C14.3166 2.90237 13.6834 2.90237 13.2929 3.29289L12 4.58579L10.7071 3.29289ZM11 7.00012H6C4.89543 7.00012 4 7.89555 4 9.00012V11.8889H11V7.00012ZM4 13.8889V17.0001C4 18.1047 4.89543 19.0001 6 19.0001H11V13.8889H4ZM13 19.0001H18C19.1046 19.0001 20 18.1047 20 17.0001V13.8889H13V19.0001ZM20 11.8889H13V7.00012H18C19.1046 7.00012 20 7.89555 20 9.00012V11.8889Z'
      fill='currentColor'
    />
  </React.Fragment>
)
